import { createContext } from 'react'
import { LOCAL_STORAGE_CURRENT_SCHOOL } from '../utils'

export class UserStore {
  person = null
  manageableSchool = null
  currentSchool = null
  schoolAccessCode = null
  needSelectProfile = null
  needSelectProfileCoordinator = null
  externalReference = null
  isUserByIntegration = null

  setNeedSelectProfile = value => {
    this.needSelectProfile = value
  }

  setIsUserByIntegration = value => {
    this.isUserByIntegration = value
  }

  setNeedSelectProfileCoordinator = value => {
    this.needSelectProfileCoordinator = value
  }

  clearLocalStorage = key => localStorage.removeItem(LOCAL_STORAGE_CURRENT_SCHOOL)

  setSchoolAccessCode = value => (this.schoolAccessCode = value)

  setPerson = value => (this.person = value)
  setManageableSchool = value => (this.manageableSchool = value)
  setCurrentSchool = value => {
    this.currentSchool = value && { ...value }

    localStorage.setItem(LOCAL_STORAGE_CURRENT_SCHOOL, JSON.stringify(this.currentSchool))
  }
  getCurrentSchool = () => {
    const encodedSchool = localStorage.getItem(LOCAL_STORAGE_CURRENT_SCHOOL)

    const decodedSchool = JSON.parse(encodedSchool)

    if (decodedSchool) {
      this.currentSchool = {
        ...decodedSchool,
      }
    }
    return this.currentSchool
  }

  setRoles = roles => (this.person.roles = roles)

  setExternalReference = externalReference => (this.externalReference = externalReference)

  setUsedAccessCode = usedAccessCode => {
    if (!this.person.usedAccessCodes.find(code => code.accessCode === usedAccessCode.accessCode)) {
      this.person.usedAccessCodes.splice(0, 0, usedAccessCode)
    }
  }
  setUsedAccessCodes = usedAccessCodes => (this.person.usedAccessCodes = usedAccessCodes)

  setPersonSchools = schools => (this.person.schools = schools)
}

export default createContext(new UserStore())
